import * as React from 'react';
import { useEffect, useRef } from 'react';

import { Props as BaseProps } from '../Notification';
import { useTheme } from '../../../theme';
import { AviaSearchParameters, InfoMessage } from '@websky/graphql';
import { createFastSearchURL } from '../../../SearchForm/utils';
import { SafeHtml } from '@shared/ui';

interface Props extends Omit<BaseProps, 'infoMessage'> {
	searchParams: AviaSearchParameters;
	infoMessage: InfoMessage;
}

const PromoNotification: React.FC<Props> = props => {
	const { PromoNotification: theme } = useTheme('Notification');
	const {
		infoMessage: { title, text, image },
		searchParams
	} = props;
	const textRef = useRef<HTMLParagraphElement>(null);

	useEffect(() => {
		if (!textRef.current) {
			return null;
		}

		const anchorElement = textRef.current.querySelector('a');
		const url = new URL(anchorElement.href);

		let actualSearchParams: AviaSearchParameters = searchParams;

		if (actualSearchParams.segments.length > 1) {
			const segmentLength = actualSearchParams.segments.length;

			// parse url iatas
			const urlIatas = decodeURI(url.hash).replace(/^#\/search\//gm, '');
			const [departureIata, arrivalIata] = [urlIatas.slice(0, 3), urlIatas.slice(3, 6)];

			// prepare RT search params by url iatas
			const lastSegment = actualSearchParams.segments[segmentLength - 1];

			actualSearchParams = {
				...actualSearchParams,
				segments: [
					...actualSearchParams.segments.slice(0, segmentLength - 1),
					{
						...lastSegment,
						departure: { ...lastSegment.departure, iata: arrivalIata },
						arrival: { ...lastSegment.arrival, iata: departureIata }
					}
				]
			};
		}

		// remove current iata codes from fast search url
		const fastSearchUrlData = createFastSearchURL(actualSearchParams).slice(6);

		url.hash += fastSearchUrlData;

		anchorElement.href = url.toString();
	}, [textRef, searchParams]);

	return (
		<div className={theme.promoNotificationWrapper}>
			<div className={theme.content} style={{ backgroundImage: `url(${image})` }}>
				<h5 className={theme.title}>{title}</h5>
				<SafeHtml tag="p" ref={textRef} className={theme.text} html={text} />
			</div>
		</div>
	);
};

export default PromoNotification;
